import {
  RESET,
  SET_SELECTED_MENU_ITEM,
  SET_SELECTED_ELEMENT,
  SET_SELECTED_CONTENT_TYPE,
  SET_READ_ONLY_ELEMENT,
  SET_EXPIRATION_DATE,
} from './actionTypes';

export const reset = () => ({
  type: RESET,
});

export const setSelectedMenuItem = (payload) => ({
  type: SET_SELECTED_MENU_ITEM,
  payload,
});

export const setSelectedElement = (payload) => ({
  type: SET_SELECTED_ELEMENT,
  payload,
});

export const setSelectedContentType = (payload) => ({
  type: SET_SELECTED_CONTENT_TYPE,
  payload,
});

export const setReadOnlyElement = (payload) => ({
  type: SET_READ_ONLY_ELEMENT,
  payload,
});

export const setExpirationDate = (payload) => ({
  type: SET_EXPIRATION_DATE,
  payload,
});
